import { render } from "./About.vue?vue&type=template&id=0ee9949d&scoped=true"
import script from "./About.vue?vue&type=script&lang=js"
export * from "./About.vue?vue&type=script&lang=js"

import "./About.vue?vue&type=style&index=0&id=0ee9949d&lang=scss"
import "./About.vue?vue&type=style&index=1&id=0ee9949d&scoped=true&lang=scss"

import exportComponent from "/pxplus_official_website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ee9949d"]])

export default __exports__